// extracted by mini-css-extract-plugin
export var button = "buttonMore-module--button--b2f67";
export var rotate = "buttonMore-module--rotate--3a441";
export var svg = "buttonMore-module--svg--f082f";
export var svgColorDarkGrey = "buttonMore-module--svgColorDarkGrey--bbca1";
export var svgColorWhite = "buttonMore-module--svgColorWhite--ebae4";